// src/pages/Login.jsx
import React, { useState } from "react";
import Toast from "../components/Toast";
import "./Login.css";
import { authFetch } from "../utils/authFetch";

export default function Login() {
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await authFetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ usuario, password }),
      });

      const data = await res.json();

      if (!res.ok || !data.ok) {
        setToast({
          mensaje: data.mensaje || "Credenciales inválidas",
          tipo: "error",
        });
        setLoading(false);
        return;
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      window.location.href = "/";
    } catch {
      setToast({ mensaje: "Error de red", tipo: "error" });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-ios">
      <div className="login-glass">
        <div className="login-brand">
          <p>ISP Control Panel</p>

          <div className="login-logo">WIFIMEX</div>       
        </div>

        <form onSubmit={submit} className="login-form">
          <div className="input-group">
            <input
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
              required
            />
            <label>Usuario</label>
          </div>

          <div className="input-group">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label>Contraseña</label>
          </div>

          <button className="login-btn" disabled={loading}>
            {loading ? (
              <span className="btn-loading">
                <span className="apple-spinner" />
                Entrando…
              </span>
            ) : (
              "Entrar"
            )}
          </button>
        </form>
      </div>

      {toast && (
        <Toast
          mensaje={toast.mensaje}
          tipo={toast.tipo}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
}
